// noinspection JSUnresolvedFunction

import {
	Button, Checkbox, FormControlLabel,
	IconButton,
	InputAdornment,
	MenuItem,
	OutlinedInput,
	Select,
	Stack, Step, StepLabel, Stepper,
	TextField
} from "@mui/material";
import {useCallback, useEffect, useState} from "react";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import {ReCAPTCHA} from "react-google-recaptcha";
import {BsPatchCheck} from "react-icons/md";
import Step01 from "./Step01";
import Step02 from "./Step02";
import Step03 from "./Step03";
import Step04 from "./Step04";
import StepSuccess from "./StepSuccess";
import FunctionsData from "../functions/FunctionsData";
const passwordValidator = require('password-validator');


export default function Register(props) {
	
	const domain = (window.location.host.includes('localhost')) ? window.location.host.replace(':6004', '') : 'talenthabitat.io';
	const [step, setStep] = useState(0);
	
	const [state,setState] = useState({
		frmEmail:'',
		frmEmailFinance:'',
		frmEmailConfirm:'',
		frmEmailAccounts:'',
		frmEmailAccountsConfirm:'',
		frmBusinessName:'',
		frmAddressFormatted:'',
		frmAddressNumber:'',
		frmAddressStreet:'',
		frmAddressPostcode:'',
		frmAddressSuburb:'',
		frmAddressCity:'',
		frmDpid:'',
		frmAddressX:0.00,
		frmAddressY:0.00,
		frmPhone:'',
		frmWebsite:'',
		frmPassword:'',
		frmPasswordConfirm:'',
		frmContactEmail:'',
		frmContactEmailConfirm:'',
		frmAcceptedDeclaration:0,
		frmAcceptedDeclarationName:'',
		frmAcceptedDeclarationPosition:'',
		frmAcceptedDeclarationDate:null,
		capacity: [
			{label:'Feline',key:'cat', slug:'feline', minimum_weight:'', minimum_age:'', day_capacity_spay:'', day_capacity_neuter:'', selected:0},
			{label:'Canine',key:'dog', slug:'canine', minimum_weight:'', minimum_age:'', day_capacity_spay:'', day_capacity_neuter:'', selected:0}
		],
		campaigns:[],
		campaignsTexts:[],
		campaignsConsent:[],
		frmInvoiced:'',
		eoi:1,
		username:'',
		accepted_type:props.acceptedType
	})
	
	
	const [frmDomainFinal, setFrmDomainFinal] = useState('');
	const [storing, setStoring] = useState(false);
	const [success, setSuccess] = useState(false);
	
	useEffect(() => {
		window.analytics.track("Entered Signup Stage");
	}, []);
	
	useEffect(() => {
		setState({...state, username:state.frmEmail})
	}, [state.frmEmail]);
	
	async function registerVet() {
		setStoring(true);
		const body = {
			business_name:state.frmBusinessName,
			email:state.frmEmail,
			phone:state.frmPhone,
			formatted_address:state.frmAddressFormatted,
			street_number:state.frmAddressNumber,
			street:state.frmAddressStreet,
			suburb:state.frmAddressSuburb,
			city:state.frmAddressCity,
			postcode:state.frmAddressPostcode,
			dpid:state.frmDpid,
			longitude:state.frmAddressX,
			latitude:state.frmAddressY,
			website:state.frmWebsite,
			password:state.frmPassword,
			accepted_declaration_date:state.frmAcceptedDeclarationDate,
			accepted_declaration_name:state.frmAcceptedDeclarationName,
			accepted_declaration_position:state.frmAcceptedDeclarationPosition,
			capacity:JSON.stringify(state.capacity),
			contact_email:state.frmContactEmail,
			campaigns:state.campaigns.join(','),
			campaignsTexts:state.campaignsTexts.join(','),
			campaigns_consent:JSON.stringify(state.campaignsConsent),
			invoiced:state.frmInvoiced,
			eoi:state.eoi,
			origin:window.location.origin,
			username:state.username,
			email_accounts:state.frmEmailFinance,
			accepted_type:props.acceptedType
		}
		
		await fetch(FunctionsData.getApiUrl('/api/register/account'), {
			method: 'POST',
			headers: {'Content-Type': 'application/json', 'token':sessionStorage.tkn},
			body: JSON.stringify(body)
		})
			.then((res) => res.json())
			.then((d) => {
				//console.log(d);
				setStep(step + 1);
				setSuccess(true);
				setStoring(false);
			})
	}
	
	const steps = [
		{label:'Clinic details',step:1},
		{label:'Select campaign',step:2},
		{label:'Declaration',step:3},
		{label:'Finalise registration',step:4}
	];
	
	return (
		<div>
			<Stepper activeStep={step} alternativeLabel>
				{steps.map((row) => (
					<Step key={row.step}>
						<StepLabel>{row.label}</StepLabel>
					</Step>
				))}
			</Stepper>
			<div className={"stepper-box"}>
				{
					(step === 0) ?
						<Step01 state={state} setState={setState}
						        step={step} setStep={setStep}
						/>
						: undefined
				}
				
				{
					(step === 1) ?
						<Step02 state={state} setState={setState}
						        step={step} setStep={setStep}
						/>
						: undefined
				}
				
				{
					(step === 2) ?
						<Step03 state={state} setState={setState}
						        step={step} setStep={setStep}
						/>
						: undefined
				}
				
				{
					(step === 3) ?
						<Step04 state={state} setState={setState}
						        step={step} setStep={setStep} registerVet={registerVet}
						/>
						: undefined
				}
				
				{
					(step === 4) ?
						<StepSuccess />
						: undefined
				}
			</div>
		
		</div>
	)
}